// Monospace tabular viewer count with an eye glyph.
import { useTranslation } from "react-i18next";
import { Eye } from "lucide-react";
import { formatCount } from "./format.js";

export function ViewerCount({ count, className }: { count: number; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={
        "inline-flex items-center gap-1.5 font-mono text-xs tabular-nums text-muted-foreground " +
        (className ?? "")
      }
      title={t("info.viewers", { count })}
    >
      <Eye className="h-3.5 w-3.5" />
      {formatCount(count)}
    </span>
  );
}
